export const buildProvenance = { "commitHash": "543047bad002ea262dc6aed3dc6a6868413917a3", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-04-15T22:38:46.361Z", "version": "2024.1.12464" };
